import * as React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import Input from 'react-phone-number-input/input'
export interface IInputPhoneProps {
    onChangeValue(val: number | string): void
    defaultValue?: string
    value?: string
    className?: string
    required?: boolean
    placeholder?: string
    onValidate?(valid: boolean): boolean
    disabled?: boolean
    readOnly?: boolean
    onChangePhone?(phoneNumber: string): void
    withCountryCallingCode?: boolean
    numberFormat?: boolean
}
const InputPhone: React.FC<IInputPhoneProps> = (props) => {
    const [numberPhone, setNumberPhone] = React.useState("");
    const [validate, setValidate] = React.useState(false);
    const inputRef = React.useRef(null)
    React.useEffect(() => {

        const result = fixFormat(props.value)
        console.log("result", result)
        if (result != numberPhone) {
            setNumberPhone(result)
        }
        // setNumberPhone(value)
    }, [props.value]);


    const onChangeText = (val) => {
        props.onChangeValue(val)
    }

    const checkValidate = (val) => {
        let valid = false
        try {
            const _val = val.toString()
            if ((_val.length >= 10 && _val.length < 14) == true) {
                valid = true;
            }

        } catch (error) {
            valid = false;
        }
        if (props.onValidate) {
            valid = props.onValidate(valid)
        }
        console.log("inputRef",inputRef)
        if (props.required && inputRef && inputRef.current) {
            if (!valid) {
                console.log("setCustomValidity", false)
                inputRef.current.setCustomValidity("Invalid field.")
            } else {
                console.log("setCustomValidity", true)
                inputRef.current.setCustomValidity("")
            }
        }


    }


    const validatePhoneNumber = (val): boolean => {
        console.log("validatePhoneNumber", val)
        let valid = false
        try {
            const _val = val.toString()
            console.log("length", _val.length)
            if ((_val.length >= 10 && _val.length < 14) == true) {
                return true
            }

        } catch (error) {
            return false;
        }
        return false;
    }

    /**
     * 
     * @param phoneNumber 
     * @returns 
     */
    const fixFormat = (phoneNumber) => {
        if (phoneNumber == undefined) {
            return ""
        }
        const regex = /^\+[1]/gm;
        const result = phoneNumber.replace(regex, '');
        return result
    }


    const format = (value) => {
        const regex = /^\+[1]\d{1,10}$/g;
        const defualtFormat = "+# (###) ###-####";
        if (!value || value == "") {
            return defualtFormat
        }
        if (regex.test(value)) {
            return "+# (###) ###-####"
        } else {
            return defualtFormat
        }
    }

    return (
        <>
            <NumberFormat
                defaultValue={`${numberPhone}`}
                value={`${numberPhone}`}
                customInput={Form.Control}
                required={props.required}
                getInputRef={inputRef}
                // getInputRef={(el) => inputPhone = el}
                // pattern="^\+[1-9]\d{1,14}$"
                // onChange={(event) => {
                //     //inputPhone.setCustomValidity("eee")
                //     onChangeText(event.target.value)
                // }}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    console.log("values", values)
                    let v = floatValue !== undefined ? floatValue : ""

                    setNumberPhone(`${v}`)
                    onChangeText(v)
                    checkValidate(floatValue)

                    if (props.required) {
                        setValidate(true)
                    }
                    if (props.onChangePhone) {
                        props.onChangePhone(formattedValue)
                    }
                }}
                isValid={props.required && validate && validatePhoneNumber(numberPhone)}
                isInvalid={props.required && validate && !validatePhoneNumber(numberPhone)}
                onBlur={() => {
                    // setValidate(true)
                }}
                // allowEmptyFormatting={true}
                className={props.className}
                format={"(###) ###-####"}
                mask="_"
                placeholder={props.placeholder}
                disabled={props.disabled}
                readOnly={props.readOnly}
            />
            {/* {!numberFormat ? <Input
                disabled={disabled}
                country="US"
                placeholder={placeholder}
                inputComponent={Form.Control}
                international={true}
                withCountryCallingCode={withCountryCallingCode}
                className={className}
                value={`${numberPhone}`}
                onChange={(val) => {
                    console.log("val.length ", val)
                    // if (val && val != "" && val.length <= 12) {
                    //     console.log(val)

                    //     onChangeText(val)
                    //     validate(val)
                    // }
                    setNumberPhone(val)
                    onChangeText(val)
                    validate(val)
                    // let v = val.length > 12 ? value : val

                }} />
                : <NumberFormat
                    defaultValue={`${numberPhone}`}
                    value={`${numberPhone}`}
                    customInput={Form.Control}
                    required={required}
                    // getInputRef={(el) => inputPhone = el}
                    // pattern="^\+[1-9]\d{1,14}$"
                    // onChange={(event) => {
                    //     //inputPhone.setCustomValidity("eee")
                    //     onChangeText(event.target.value)
                    // }}
                    onValueChange={(values) => {
                        const { formattedValue, value, floatValue } = values;
                        console.log("values", values)
                        let v = floatValue !== undefined ? floatValue : ""

                        setNumberPhone(`${v}`)
                        onChangeText(v)
                        validate(floatValue)
                        if (onChangePhone) {
                            onChangePhone(formattedValue)
                        }
                    }}
                    // allowEmptyFormatting={true}
                    className={className}
                    format={"(###) ###-####"}
                    mask="_"
                    placeholder={placeholder}
                    disabled={disabled}
                    readOnly={readOnly}
                />} */}
        </>
    )

}
InputPhone.defaultProps = {
    required: false,
    placeholder: "",
    className: "",
    defaultValue: "",
    withCountryCallingCode: true,
    disabled: false,
}
export default InputPhone;
export { InputPhone }
